// extracted by mini-css-extract-plugin
export default {"timeDiv":"unit-text_timeDiv__WUbzr","unitText":"unit-text_unitText__zm3yB"};